import React from 'react';
import ClaimInfoCard from '../../routes/projects/project-execution/invoices/claim-info-card';

/**
 * InvoiceSummaryCards - Reusable presentational component for invoice financial summary cards.
 *
 * Props:
 *  - claimed  {string} — Pre-formatted "Total Amount Claimed" value (e.g. "$1,200.00")
 *  - retention {string} — Pre-formatted "Total Retention" value
 *  - approved  {string} — Pre-formatted "Amount Approved" value
 */
const InvoiceSummaryCards = ({ claimed, retention, approved }) => {
  return (
    <div className="row mb-4">
      <div className="col-md-4">
        <ClaimInfoCard
          title="Total Amount Claimed"
          amount={claimed}
          customStyleClass="total-claimed"
          data-cy="total-amount-claimed-card"
        />
      </div>
      <div className="col-md-4">
        <ClaimInfoCard
          title="Total Retention"
          amount={retention}
          customStyleClass="total-retention"
          data-cy="total-retention-card"
        />
      </div>
      <div className="col-md-4">
        <ClaimInfoCard
          title="TOTAL AMOUNT"
          amount={approved}
          customStyleClass="amount-approved"
          data-cy="amount-approved-card"
        />
      </div>
    </div>
  );
};

export default InvoiceSummaryCards;
